import { observable, action } from 'mobx';
import { Properties } from 'api';

class PropertyStore {
  @observable property;

  @observable fetchState;

  anketId;

  propertyId;

  @action.bound
  async getProperty(anketId, propertyId) {
    if (this.anketId === anketId && this.propertyId === propertyId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Properties.getProperty(anketId, propertyId);
      this.property = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
      this.propertyId = propertyId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const propertyStore = new PropertyStore();

export default propertyStore;
